import defaultAxios from 'axios';
import * as Path from './paths';

const PROD_URL = 'https://games.weplay.africa';

const DEV_URL = PROD_URL;
const SECOND_URL = 'https://rewards.weplay.africa';

const __PROD__ = !process.env.NODE_ENV || process.env.NODE_ENV === 'production';

const baseUrl = __PROD__ ? PROD_URL : DEV_URL;

export const axios = defaultAxios.create({
    baseURL: baseUrl,
});

export const secondAxios = defaultAxios.create({
    baseURL: SECOND_URL,
});

function getImageUrl(url?: string) {
    try {
        if (typeof url === 'string' && url?.startsWith('/files/')) {
            return baseUrl.concat(url);
        }
        return url;
    } catch (e: any) {
        console.log(e?.message, url);
        return url;
    }
}

export const API = {
    get: axios.get,
    post: axios.post,
    patch: axios.patch,
    delete: axios.delete,
    put: axios.put,
    PATH: Path,
    baseUrl: baseUrl,
    CancelToken: defaultAxios.CancelToken,
    getImageUrl: getImageUrl,
};

export const SECOND_API = {
    get: secondAxios.get,
    post: secondAxios.post,
    patch: secondAxios.patch,
    delete: secondAxios.delete,
    put: secondAxios.put,
    PATH: Path,
    baseUrl: SECOND_URL,
    CancelToken: defaultAxios.CancelToken,
};
